// extracted by mini-css-extract-plugin
export default {"container":"FormFooter_container__2Kg-M","cancelButton":"FormFooter_cancelButton__LTlRA","submitButton":"FormFooter_submitButton__6jWFz"};